require("prismjs/themes/prism.css")

// Note: The Script Adds CLUTCHCO property to DOM Window object
const injectClutchScript = () => {
  const script = document.createElement("script")
  script.type = `text/javascript`
  script.src = "https://widget.clutch.co/static/js/widget.js"
  script.async = true
  document.getElementsByTagName(`head`)[0].appendChild(script)
}
exports.onClientEntry = () => {
  injectClutchScript()
}
